import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

const RedirectToDocument = ({ basePath = "/documents" }) => {
  const navigate = useNavigate();
  const { documentId } = useParams();

  useEffect(() => {
    if (documentId) {
      const targetPath = `${basePath}/${documentId}`;
      navigate(targetPath, { replace: true });
    }
  }, [documentId, navigate, basePath]);

  return null;
};

export default RedirectToDocument;
